import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-complete',
    templateUrl: './complete.component.html',
    styleUrls: ['./complete.component.scss']
})
export class CompleteComponent implements OnInit {

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute) {
        this.activeRoute.queryParams.subscribe((e) => {
            this.image = e.g;
        });
    }
    image: any = null;
    assetUrl = environment.assetUrl;

    done(): void {
        this.router.navigate(['/home'], { replaceUrl: true });
    }

    ngOnInit(): void {
    }

}
